import UIModuleExport from './UIModuleExport';

export default UIModuleExport;
